<div id="poster-adding-form" class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{ 'POSTER_COMPONENT.ADD_POSTER' | translate }}</h2>
        </mat-toolbar-row>
    </mat-toolbar>

    <div class="center poster-adding-list-panel">
        <div class="panel-body p-8" fusePerfectScrollbar>
            <app-poster-list
                [isMulti]='true'
                [posterList]="posterList"
                (selectedPosterEmitter)="selectPoster($event)"
            ></app-poster-list>
            <div class="clearfix"></div>
        </div>
    </div>

    <div
        mat-dialog-actions
        class="m-0"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button
            mat-raised-button
            color="primary"
            class="no-button"
            (click)="onNoClick()"
        >
            {{ 'COMMON.CLOSE' | translate }}
        </button>
        <button
            mat-raised-button
            color="accent"
            class="yes-button"
            [mat-dialog-close]="selectedPoster"
            [disabled]='!selectedPoster || !selectedPoster.length'
        >
            {{ 'POSTER_COMPONENT.ADD_POSTER' | translate }}
        </button>
    </div>
</div>
